import React, { useState } from "react";
import styled from "styled-components/macro";
import logoTrue from "../assets/icons/truemedslogosvglong.svg";
import { rgba } from "polished";
import { NavLink, withRouter } from "react-router-dom";
import { darken } from "polished";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../vendor/perfect-scrollbar.css";
import { ROLES } from "../constants/index";
import { VscCircleLargeFilled } from "react-icons/vsc";
import {
  Chip,
  Collapse,
  Drawer as MuiDrawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { sidebarRoutes as routes } from "../routes/index";
import { connect } from "react-redux";
import roleRedirect from "./RoleRedirect/RoleRedirect";
import UserDropdown from "./UserDropdown";
import { MdCircle } from "react-icons/md";
import { Divider } from "antd";

const Drawer = styled(MuiDrawer)`
  border-right: 0;
  transition: all 1s ease-in-out;

  .MuiBackdrop-root {
    backdrop-filter: blur(50px);
    background-color: rgba(0, 0, 0, 0.2);
  }

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const List = styled(MuiList)`
  background-color: ${(props) => props.theme.sidebar.background};
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)}px;
  padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
`;

const Brand = styled(ListItem)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)}px;
  padding-right: ${(props) => props.theme.spacing(6)}px;
  justify-content: center;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled.img`
  margin-right: ${(props) => props.theme.spacing(2)}px;
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 50%;
  min-width: 120px;
  height: 32px;
`;

const Category = styled(ListItem)`
  padding-top: ${(props) => props.theme.spacing(3)}px;
  padding-bottom: ${(props) => props.theme.spacing(3)}px;
  padding-left: ${(props) => props.theme.spacing(8)}px;
  padding-right: ${(props) => props.theme.spacing(7)}px;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  svg {
    color: ${(props) => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const CategoryText = styled(ListItemText)`
  margin: 0;
  span {
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    padding: 0 ${(props) => props.theme.spacing(4)}px;
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${(props) => props.theme.spacing(17.5)}px;
  padding-top: ${(props) => props.theme.spacing(2)}px;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;

  span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.9)};
  }

  &:hover {
    background-color: ${(props) =>
      darken(0.015, props.theme.sidebar.background)};
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const UserMenu = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  color: #1e1e1e;
  font-weight: 600;
  cursor: pointer;
  padding: 0;

  span {
    line-height: normal;
  }

  svg {
    font-size: 22px;
    color: ${(props) => (props.online ? "#22b573" : "#e55934")};
  }
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};
  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 28px;
  top: 8px;
  background: ${(props) => props.theme.sidebar.badge.background};

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${(props) => props.theme.sidebar.badge.color};
    padding-left: ${(props) => props.theme.spacing(2)}px;
    padding-right: ${(props) => props.theme.spacing(2)}px;
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  padding: ${(props) => props.theme.spacing(4)}px
    ${(props) => props.theme.spacing(7)}px
    ${(props) => props.theme.spacing(1)}px;
  opacity: 0.9;
  display: block;
`;

const SidebarFooter = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}px
    ${(props) => props.theme.spacing(4)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  width: 100%;

  .flexLink {
    display: block;
    width: 100%;
    position: relative;

    li:hover {
      background: transparent;
    }

    .MuiButtonBase-root {
      position: absolute;
      top: 50%;
      left: 0;
      background: transparent;
      transform: translate(0%, -50%);
    }
  }
`;

const SidebarCategory = ({
  name,
  icon,
  classes,
  isOpen,
  isCollapsable,
  badge,
  onClose,
  ...rest
}) => {
  return (
    <Category {...rest}>
      {icon}
      <CategoryText>{name}</CategoryText>
      {isCollapsable ? (
        isOpen ? (
          <CategoryIconMore />
        ) : (
          <CategoryIconLess />
        )
      ) : null}
      {badge ? <CategoryBadge label={badge} /> : ""}
    </Category>
  );
};

const SidebarLink = ({ name, to, badge, icon }) => {
  return (
    <Link
      button
      dense
      component={NavLink}
      exact
      to={to}
      activeClassName="active"
    >
      <LinkText>{name}</LinkText>
      {badge ? <LinkBadge label={badge} /> : ""}
    </Link>
  );
};

const Sidebar = ({
  classes,
  staticContext,
  location,
  loginInfo,
  isOnline,
  onClose,
  ...rest
}) => {
  const initOpenRoutes = () => {
    /* Open collapse element that matches current url */
    const pathName = location.pathname;

    let _routes = {};

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/";

      _routes = Object.assign({}, _routes, {
        [index]: isActive || isOpen || isHome,
      });
    });

    return _routes;
  };

  const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes());

  const toggle = (index) => {
    // Collapse all elements
    Object.keys(openRoutes).forEach(
      (item) =>
        openRoutes[index] ||
        setOpenRoutes((openRoutes) =>
          Object.assign({}, openRoutes, { [item]: false })
        )
    );

    // Toggle selected element
    setOpenRoutes((openRoutes) =>
      Object.assign({}, openRoutes, { [index]: !openRoutes[index] })
    );
  };

  const sideBarItem = (category, index) => {
    return (
      <React.Fragment key={index}>
        {category.header ? (
          <SidebarSection>{category.header}</SidebarSection>
        ) : null}

        {category.children && category.icon ? (
          <React.Fragment key={index}>
            <SidebarCategory
              isOpen={!openRoutes[index]}
              isCollapsable={true}
              name={category.id}
              icon={category.icon}
              button={true}
              onClick={() => toggle(index)}
            />

            <Collapse in={openRoutes[index]} timeout="auto" unmountOnExit>
              {category.children.map((route, index) => (
                <SidebarLink
                  key={index}
                  name={route.name}
                  to={route.path}
                  icon={route.icon}
                  badge={route.badge}
                />
              ))}
            </Collapse>
          </React.Fragment>
        ) : category.icon ? (
          <SidebarCategory
            isCollapsable={false}
            name={category.id}
            to={category.path}
            activeClassName="active"
            component={NavLink}
            icon={category.icon}
            exact
            button
            badge={category.badge}
          />
        ) : null}
      </React.Fragment>
    );
  };

  // ------------- Update TO ROles here
  let isTOPicker = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.TO_PICKER_ROLE
    )
  ) {
    isTOPicker = true;
  }

  // ------------- Update TO Packer Role here

  let isTODispatch = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.TO_DISPATCH_ROLE
    )
  ) {
    isTODispatch = true;
  }

  let isTOPacker = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.TO_PACKER_ROLE
    )
  ) {
    isTOPacker = true;
  }

  // ------------- Update TO ROles here
  let isTOChecker = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.TO_CHECKER_ROLE
    )
  ) {
    isTOChecker = true;
  }

  // ------------- TO Bin Picker
  let isTOBinPicker = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.BIN_TRANSFER
    )
  ) {
    isTOBinPicker = true;
  }

  // ------------- TO Bin Racker
  let isTOBinRacker = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.BIN_TRANSFER
    )
  ) {
    isTOBinRacker = true;
  }

  // ------------- Put Away
  let isPutAway = null;
  if (
    loginInfo.AuthData?.userDTO.role.find(
      (o) => o.roleName === ROLES.PUT_AWAY_ROLE
    )
  ) {
    isPutAway = true;
  }

  const toLink = loginInfo.AuthData
    ? roleRedirect(loginInfo.AuthData?.userDTO)
    : "/";

  return (
    <Drawer onClose={onClose} variant="permanent" {...rest}>
      <Brand component={NavLink} to={toLink} button>
        <br />
        <BrandIcon src={logoTrue} alt="Truemeds" style={{ height: "auto" }} />
        {/* <Box ml={1}>Truemeds</Box> */}
      </Brand>
      <Scrollbar>
        <List disablePadding>
          <Items>
            {routes.map((category, index) => {
              return category.id === "TO_PICKER_HOMEPAGE"
                ? isTOPicker
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "TO_CHECKER_HOMEPAGE"
                ? isTOChecker
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "BIN_TO_BIN_PICK"
                ? isTOBinPicker
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "BIN_TO_BIN_RACK"
                ? isTOBinRacker
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "PUT_AWAY_INVOICES"
                ? isPutAway
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "TO_CONTAINER_PACKING"
                ? isTOPacker
                  ? sideBarItem(category, index)
                  : ""
                : category.id === "PRINT_PACK_SLIP"
                ? isTODispatch
                  ? sideBarItem(category, index)
                  : ""
                : //? Rest View
                  "";
            })}
          </Items>
        </List>
      </Scrollbar>
      <SidebarFooter>
        <List disablePadding to={"/Profile"}>
          <Items className="flexLink">
            <UserMenu
              onClick={() => rest.history.push("/Profile")}
              online={isOnline}
            >
              <MdCircle />
              <span>
                {`${loginInfo?.AuthData?.userDTO?.firstName} ${loginInfo?.AuthData?.userDTO?.lastName}`}
              </span>
            </UserMenu>

            <Divider style={{ margin: "1.5em 0" }} />

            {/* <SidebarCategory
              icon={<VscCircleLargeFilled style={{ color: "#22B573" }} />}
            />
            <SidebarLink
              to={"/Profile"}
              name={`${loginInfo?.AuthData?.userDTO.firstName} ${loginInfo?.AuthData?.userDTO.lastName}`}
            /> */}

            <UserDropdown active={false} />
          </Items>
        </List>
      </SidebarFooter>
    </Drawer>
  );
};
const mapStateToProps = (state) => {
  return {
    loginInfo: state.authReducer,
    isOnline: state.statusReducer.isOnline,
  };
};
export default withRouter(connect(mapStateToProps)(Sidebar));
